import CommonStatus from './CommonStatus';

export default class Fsdo extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { status } = this.props;
        switch(status) {
            default: return <CommonStatus status={status} />;
        }
    }
}